import { useMemo } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { TENANT_ID } from "../../components/Utils";
import { RewampLocalizationService } from "./RewampLocalizationService";
import { REWAMP_LOCALE_NAMESPACE, resolveModuleCode } from "./constants";

/**
 * @param {string[]} domains - keys of REWAMP_LOCALE_MODULES (constants.js)
 */
export const useRewampLocalization = (domains = []) => {
  const { i18n } = useTranslation(REWAMP_LOCALE_NAMESPACE);
  const domainsKey = domains.join(",");
  const modules = useMemo(
    () => domains.map(resolveModuleCode).filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [domainsKey]
  );

  return useQuery(
    ["RewampLocale", modules, i18n.language],
    () =>
      RewampLocalizationService.getLocale({
        modules,
        locale: i18n.language,
        tenantId: TENANT_ID,
      }),
    { enabled: modules.length > 0, staleTime: Infinity }
  );
};
